import {
    URLAPI,
    RISK_IMPACT_PATH,
    RISK_IMPACT_CREATE_PATH,
    RISK_IMPACT_UPDATE_PATH,
} from "../config/index";
import {LOGOUT} from './users'
import axios from "axios";

const init = {
    _get_all_risk_impact: {
        data: [],
        status: 0,
        message: {},
    },
    _create_risk_impact: {
        data: {},
        status: 0,
        message: {},
    },
    _update_risk_impact: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_RISK_IMPACT = "GET_ALL_RISK_IMPACT";
export const CREATE_RISK_IMPACT = "CREATE_RISK_IMPACT";
export const UPDATE_RISK_IMPACT = "UPDATE_RISK_IMPACT";

export const risk_impact_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_RISK_IMPACT:
            return {
                ...state,
                _get_all_risk_impact: action.payload,
            };
        case CREATE_RISK_IMPACT:
            return {
                ...state,
                _create_risk_impact: action.payload,
            };
        case UPDATE_RISK_IMPACT:
            return {
                ...state,
                _update_risk_impact: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllRiskImpact = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${RISK_IMPACT_PATH}`, {
            headers: {
                Authorization: `Basic ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_RISK_IMPACT,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_RISK_IMPACT,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_RISK_IMPACT,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const createRiskImpact = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${RISK_IMPACT_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_RISK_IMPACT,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_RISK_IMPACT,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_RISK_IMPACT,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateRiskImpact = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${RISK_IMPACT_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_RISK_IMPACT,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_RISK_IMPACT,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_RISK_IMPACT,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_risk_impact = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
